import { Injectable } from '@angular/core';
import { StorageEngine } from '@ngxs/storage-plugin';
import _get from 'lodash.get';
import _isEqual from 'lodash.isequal';
import { environment } from 'src/environments/environment';
import { APP_CONFIG_DEFAULTS } from 'vnext-shared';

@Injectable()
export class VNextStorageEngine implements StorageEngine {
  appConfig;
  get length(): number {
    // length represents the number of top level storage elements (currently application, ui, liveEdit)
    return sessionStorage.length;
  }

  getItem(key: string): any {
    const sessionStorageItem = sessionStorage.getItem(key);

    if (!environment.liveedit && sessionStorageItem && key === 'application') {
      return JSON.stringify({ ...JSON.parse(sessionStorageItem), appConfig: this.getAppConfig() });
    }

    return sessionStorageItem;
  }

  setItem(key: string, val: any): void {
    // Performance: tasks like setting items to session storage do not need to be executed prior application logic and page rendering.
    // As a result we should use setTimeout 0 to push these items to the end of the call stack to free up the DOM earlier.
    setTimeout(() => {
      const value = JSON.parse(val);
      if (!environment.liveedit && key === 'application') {
        // move appConfig into memory
        const appConfig = _get(value, 'appConfig');
        this.appConfig = appConfig;
        delete value['appConfig'];
      }

      sessionStorage.setItem(key, JSON.stringify(value));
    }, 0);
  }

  removeItem(key: string): void {
    // We aren't actually removing any top level sessionStorage items but if we did we
    // would delegate to the native API. If we find a use case for this we may want to
    // set appConfig back to defaults when application is removed but this situation
    // does not currently come up.
    sessionStorage.removeItem(key);
  }

  clear(): void {
    // We aren't actually clearing any top level sessionStorage items but if we did we
    // would delegate to the native API. If we find a use case for this we may want to
    // set appConfig back to defaults here but this situation does not currently come up.
    sessionStorage.clear();
  }

  key(val: number): string {
    return sessionStorage.key(val);
  }

  private getAppConfig() {
    return this.appConfig || APP_CONFIG_DEFAULTS;
  }
}
